import { EditUnitFormType, EditUnitOptions } from '@mark43/cad-api';
import { Control } from 'react-hook-form';
import { useIsFetching } from '@tanstack/react-query';
import { FormSelect } from '../../forms/integrated-form-controls/form-select';
import { sortCallSignOptions } from './helpers/call-sign-sort';

export function CallSignSelect({
    formFieldOptions,
    control,
}: {
    formFieldOptions: EditUnitOptions;
    control: Control<EditUnitFormType>;
}): React.ReactElement {
    const isFetching = useIsFetching(['edit-unit-view', 'edit-unit-bootstrap']);
    return (
        <FormSelect
            autoFocus={true}
            name="callSign"
            label="Call Sign"
            control={control}
            rules={{
                required: 'Required',
            }}
            isLoading={!!isFetching}
            options={formFieldOptions.callSignOptions}
            sortOptions={sortCallSignOptions}
        />
    );
}
